/**
 *  Components Library file
 *  @memberOf components.Button
 */

import classnames from "~utils/classnames/classnames";

import Icon, { IconName } from "~ts_components/Icon/Icon";

type ButtonVariant = "primary" | "outline";
type ButtonSize = "sm" | "md";

const VARIANT_CLASSNAMES: Record<ButtonVariant, string> = {
  primary: "bg-black text-white",
  outline: "border-2 border-grey-border text-black hover:border-black ",
};

const SIZE_CLASSNAMES: Record<ButtonSize, string> = {
  sm: "size-9",
  md: "size-11",
};

export type ButtonVisualProps = {
  iconName: IconName;
  variant?: ButtonVariant;
  size?: ButtonSize;
  className?: string;
  iconClassName?: string;
};

const IconButtonVisual = ({
  iconName,
  variant = "primary",
  size = "md",
  className,
  iconClassName,
}: ButtonVisualProps) => {
  return (
    <span
      className={classnames(
        "inline-flex cursor-pointer items-center justify-center rounded-full transition duration-300 ease-in-out group-disabled:cursor-not-allowed group-disabled:opacity-50",
        VARIANT_CLASSNAMES[variant],
        SIZE_CLASSNAMES[size],
        className,
      )}
    >
      <Icon
        name={iconName}
        iconClassName={classnames("size-5", iconClassName)}
      />
    </span>
  );
};

export default IconButtonVisual;
